import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { fetchBecomeMemberBanner, fetchBecomeMemberFrom, fetchMemberShipType, getToken } from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";
import MemberBanner from "../components/member/MemberBanner";
import { IBannerData, IBecomeMemberFromData, IMemberShipType } from "../exports/interfaces";
import BecomeMemberForm from "../components/member/BecomeMemberForm";

const BecomeMember = () => {
  const { setLoading } = useLoader();
  const [becomeMememberBannerData, setBecomeMememberBannerData] = useState<
    IBannerData[]
  >([]);
  const [becomeMemberData, setBecomeMememberData] = useState<IBecomeMemberFromData[]>([]);
  const [membershipType, setMembershipType] = useState<IMemberShipType[]>([]);
  const [token, setToken] = useState<string>("");
  useEffect(() => {
    setLoading(true);
      Promise.all([fetchBecomeMemberBanner(), fetchBecomeMemberFrom(), getToken(), fetchMemberShipType()])
        .then(([becomeMemberBannerData, becomeMemberData, tokenData, memberShipTypeData]) => {
          setBecomeMememberBannerData(becomeMemberBannerData);
          setBecomeMememberData(becomeMemberData);
          setToken(tokenData[0]?.attributes?.Token);
          setMembershipType(memberShipTypeData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          dynamicFailed("Server Error");
        });
  }, [becomeMememberBannerData.length, setLoading]);
  return (
    <>
      <MemberBanner becomeMememberBannerData={becomeMememberBannerData} />
      <BecomeMemberForm becomeMemberData={becomeMemberData} token={token} membershipType={membershipType}/>
    </>
  );
};

export default BecomeMember;
